import React from 'react';
import './App.css';
import UnityLoader from './components/UnityLoader';
import LiveKit from './components/LiveKit';
import decodeToken from './utils/jwtDecoder';
import useAuth from './hooks/useAuth'
// import PlayPauseButton from './components/core/PlayPauseButton';

function App() {
  const { setSessionDataAction } = useAuth()
  React.useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const token = queryParams.get("token"); // Retrieve the token from query parameters

    if (token) {
      const decodedData = decodeToken(token);
      console.log("Decoded JWT data:", decodedData);
      setSessionDataAction(decodedData);
    } else {
      console.log("Token not found in query parameters");
      setSessionDataAction(null);
    }
  }, []);
  return (
    <div className="App">
      <header className="App-header">
      </header>
      <body>
        <LiveKit >
          <UnityLoader />
        </LiveKit>
        {/* <PlayPauseButton /> */}
      </body>
    </div>
  );
}

export default React.memo(App);
